import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, useEffect, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
} from "@mui/material";
import * as moment from 'moment';
// components
import Page from "../components/Page";
import AddMember from "./AddMember";
import Scrollbar from "../components/Scrollbar";
import Iconify from "../components/Iconify";
import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
} from "../sections/@dashboard/user";
import Axios from "../axios";

//
import { fDate } from "../utils/formatTime";
import { fPhone } from "../utils/formatNumber";
import BranchSelect from "./BranchList";
// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: "", label: "", alignRight: false },
  { id: "firstName", label: "First Name", alignRight: false },
  { id: "lastName", label: "Last Name", alignRight: false },
  { id: "cin", label: "CIN", alignRight: false },
  { id: "birthday", label: "Birthday", alignRight: false },
  { id: "phoneNumber", label: "Phone Number", alignRight: false },
  { id: "gender", label: "Gender", alignRight: false },
  { id: "isActive", label: "Status", alignRight: false },
  { id: "branchid", label: "Branch", alignRight: false },
  { id: "" },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.firstName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

// Start ------------------------------
export default function Members() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("first_name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [open, setOpen] = useState(false);
  const [menu, setMenu] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("")
  const [branchesById, setBranchedById]= useState({})
// Faridabad - 67a1b6c18d91b1d977b6aa18
// Delhi - 6783f7ff6c495485cf3486a0
  const [members, setMembers] = useState([]);

  useEffect(() => {
    Axios.get(`/api/members/`).then((response) => {
      setMembers(response.data);
    });
  }, [open, menu]);

  useEffect(() => {
    Axios.get(`/api/branches/`).then((response) => {
      console.log("response for branches!", response)
    });
  }, []);

  useEffect(() => {
    Axios.get("/api/members/branch/branchId=67a1b6c18d91b1d977b6aa18")
    .then(resp => console.log("Members of Faridabad Branch:", resp.data))
    .catch(error => console.error("API Error:", error.response));
  }, []);
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.firstName);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleNewUser = () => {
    setOpen(!open);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(
    members,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;
  const checkSubscriptions = (row) => {
    const danger = '#f2c0c0';
    const warning = '#f2f0c0';
    const currentDate = moment(new Date());
    if (row.subscriptions.length) {
      const expireDate = moment(row.subscriptions[0].expireOn);
      const checkDays = expireDate.diff(currentDate, 'days');
      if (checkDays <= 7 && checkDays > 1) {
        return danger;
      }
      if (checkDays <= 1) {
        return warning;  
      }
      return '';
  }
  };
  return (
    <Page title="Members | My Gym">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Members
          </Typography>
          <Container
            sx={{
              display: 'flex',
              flexDirection: 'row',
              
              justifyContent: "flex-end",
              gap: "10px",
              alignItems: 'center', // Vertically aligns items to the center
            }}
          >
      <BranchSelect setBranchedById={setBranchedById} setSelectedBranch={setSelectedBranch} />
          <Button
            variant="contained"
            component={RouterLink}
            to="#"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={handleNewUser}
          >
            New Member
          </Button>
          </Container>
        </Stack>
        <AddMember isOpen={open} toggle={handleNewUser} />

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={members.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {

                    
                      const isItemSelected =
                        selected.indexOf(row.firstName) !== -1;
                      return (
                        
                        (selectedBranch===row.branch || selectedBranch==="") && 
                        <TableRow
                          hover
                          key={row._id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                          style={{
                            backgroundColor:checkSubscriptions(row)
                          }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) =>
                                handleClick(event, row.firstName)
                              }
                            />
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                            >
                              <Avatar alt={row.cin} src={row.profilePic} />
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{row.firstName}</TableCell>
                          <TableCell align="left">{row.lastName}</TableCell>
                          <TableCell align="left">{row.cin}</TableCell>
                          <TableCell align="left">
                            {row.birthday ? fDate(row.birthday):'NA'}
                          </TableCell>
                          <TableCell align="left">
                            {row.phoneNumber ? fPhone(row.phoneNumber):'NA'}
                          </TableCell>
                          <TableCell align="left">{row.gender}</TableCell>
                         
                          <TableCell align="left">
                            {row.isActive ? "Yes" : "No"}
                          </TableCell>

                          <TableCell align="left" sx={{ fontSize: '12px' }}>
                            {branchesById[row.branch]}
                          </TableCell>
                          {/* <TableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                (row.is_active === "banned" && "error") || "success"
                              }
                            >
                              {sentenceCase(status)}
                            </Label>
                          </TableCell> */}

                          <TableCell align="right">
                            <UserMoreMenu member={row} menu={menu} setMenu={setMenu} setMembers={setMembers}/>
                          </TableCell>
                        </TableRow>
                     
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={members.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
